import { useState, useEffect, useContext } from "react";
import { FaCalculator, FaCalendar } from "react-icons/fa";
import Pager from "components/ui/controls/pager/pager";
import { AppContext } from "components/app/RemExprertProvider";
import DateDepartRetraiteCumulEmploi from "./DateDepartRetraite cumul emploi";
import RegmimesLiquidablesCumulEmploi from "./Regimes liquidables cumul emploi";

const ParamRetraitePageModalCumulEmploi = (props) => {
  const context = useContext(AppContext);
  const [currentPage, setCurrentPage] = useState(1);

  useEffect(() => {
    setCurrentPage(1);
  }, [props.visible]);
  return (
    <>
      <Pager
      id="paramRetraitePager"
        withMenu
        pages={[
          {
            isTitle: true,
            title: "Paramètres",
            subTitle: "Paramètres de la retraite",
          },
          {
            label: "Date de départ",
            icon: <FaCalendar />,
            content: <DateDepartRetraiteCumulEmploi Outil="" ClientConjoint={props.ClientConjoint} />,
          },
          {
            label: "Régimes liquidables",
            icon: <FaCalculator />,
            content: <RegmimesLiquidablesCumulEmploi Outil="" ClientConjoint={props.ClientConjoint}/>,
          },
        ]}
        page={currentPage}
        onPageChange={(page) => {
          setCurrentPage(page);
          
          
        }}
        navButtons={{
          // cancel: {},
          previous: {},
          next: {},
          validate: {
            onClick: (evt) => {

                context.handleCalculCumulEmploiRetraite(props.ClientConjoint,context.state);
              props.onClose();
            },
          },
        }}
      />
    </>
  );
};

export default ParamRetraitePageModalCumulEmploi;
